import { render, staticRenderFns } from "./memberStaff.vue?vue&type=template&id=aab5db60&scoped=true"
import script from "./memberStaff.vue?vue&type=script&lang=js"
export * from "./memberStaff.vue?vue&type=script&lang=js"
import style0 from "./memberStaff.vue?vue&type=style&index=0&id=aab5db60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab5db60",
  null
  
)

export default component.exports